/* FNDRY — about / our story */
(function () {
  'use strict';

  var SELECTOR = '[data-fndry-story]';
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  function slice(list) {
    return Array.prototype.slice.call(list);
  }

  function Story(root) {
    if (root.dataset.fndryStoryReady === 'true') return;
    root.dataset.fndryStoryReady = 'true';

    var revealEls = slice(root.querySelectorAll('[data-fst-reveal]'));
    var animate = root.dataset.fstAnimate === 'true';

    if (animate && !reduceMQ.matches && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) entry.target.classList.add('is-in');
            /* Re-arm only once the element has left downwards, so it plays
               again on the next approach instead of firing once on load —
               otherwise the editor's scroll-to-section spends the reveal. */
            else if (entry.boundingClientRect.top > 0) entry.target.classList.remove('is-in');
          });
        },
        { threshold: 0, rootMargin: '0px 0px -20% 0px' }
      );
      revealEls.forEach(function (el) {
        io.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('is-in');
      });
    }

    /* ---------- theme editor ---------- */

    function onBlockSelect(event) {
      if (!document.body.contains(root)) return;
      var id = event.detail && event.detail.blockId;
      if (!id) return;
      var target = root.querySelector('[data-block-id="' + id + '"]');
      if (!target) return;
      target.scrollIntoView({
        block: 'center',
        behavior: reduceMQ.matches ? 'auto' : 'smooth'
      });
    }
    document.addEventListener('shopify:block:select', onBlockSelect);
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var found = slice(context.querySelectorAll(SELECTOR));
    if (context.matches && context.matches(SELECTOR)) found.unshift(context);
    found.forEach(function (el) {
      try {
        new Story(el);
      } catch (error) {
        /* Never leave copy stranded at opacity 0. */
        el.setAttribute('data-fst-animate', 'false');
        slice(el.querySelectorAll('[data-fst-reveal]')).forEach(function (node) {
          node.classList.add('is-in');
        });
        if (window.console) console.error('[fndry-story]', error);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
